const getEnvironmentSpecificSettings = (env) => {
  switch (env) {
    case "prod":
      return {
        oktaClientId: `${process.env.REACT_APP_PROD_OKTA_CLIENT_ID}`,
        ReportBasePath: "https://gcp-prd2k19sq16.tv.local/Reports/report/OSO/",
      };

    case "qa":
      return {
        oktaClientId: `${process.env.REACT_APP_QA_OKTA_CLIENT_ID}`,
        ReportBasePath:
          "http://dev2k12sq14.tv.local/Reports_DEV01/Pages/Report.aspx?ItemPath=%2fOSO%2f",
      };

    case "uat":
      return {
        oktaClientId: `${process.env.REACT_APP_UAT_OKTA_CLIENT_ID}`,
        ReportBasePath:
          "http://dev2k12sq14.tv.local/Reports_DEV01/Pages/Report.aspx?ItemPath=%2fOSO_UAT%2f",
      };

    default:
      return {
        oktaClientId: `${process.env.REACT_APP_DEV_OKTA_CLIENT_ID}`,
        ReportBasePath:
          "http://dev2k12sq14.tv.local/Reports_DEV01/Pages/Report.aspx?ItemPath=%2fOSO%2f",
      };
  }
};

const getConfig = (basePath, env) => ({
  GetAllDepartment: `${basePath}/MasterData/GetAllDepartment`,
  GetClassByDepartment: `${basePath}/MasterData/GetClassByDepartment`,
  GetSubClassByClass: `${basePath}/MasterData/GetSubClassByClass`,
  GetAllDiscount: `${basePath}/Discount/AllDiscountItemsByFilters`,
  GetDiscountByFilter: `${basePath}/Planogram/AllPlanogramAndDiscountItemsByFilters`,
  SaveDiscount: `${basePath}/Discount/SaveDiscount`,
  GetAllPlanogram: `${basePath}/Planogram/GetAllPlanogramItems`,
  GetPlanogramByFilter: `${basePath}/Planogram/GetAllItemsByFilter`,
  AllPlanogramItemsByFilter: `${basePath}/Planogram/AllPlanogramItemsByFilters`,
  AllPlanogramItemsByFilterV2: `${basePath}/Planogram/AllPlanogramItemsByFiltersapi`,
  SavePlanogram: `${basePath}/Planogram/SavePlanogram`,
  GetAvailableCreditLimit: `${basePath}/Planogram/GetAvailableCreditLimit`,
  GetOrdersByFilter: `${basePath}/Order/AllOrdersByFilter`,
  SaveDates: `${basePath}/Order/SaveReleaseDate`,
  DeleteDates: `${basePath}/Order/DeleteDate`,
  CreatePONumber: `${basePath}/Order/CreatePONumber`,
  GetProjectStatusSummary: `${basePath}/ProjectSummary/GetProjectStatusSummary`,
  GetProjectTypeSummary: `${basePath}/ProjectSummary/GetProjectTypeSummary`,
  GetProjectCreatedSummary: `${basePath}/ProjectSummary/GetProjectCreatedSummary`,
  GetAllMasterData: `${basePath}/MasterData/GetAllMasterData`,
  AdvanceSearch: `${basePath}/OrderSetup/GetProjectListAndAdvanceSearch`,
  GetOrdersById: `${basePath}/OrderSetup/GetOrdersById`,
  UpdateOrder: `${basePath}/OrderSetup/UpdateOrder`,
  CreateOrder: `${basePath}/OrderSetup/CreateOrder`,
  GetStoreDetails: `${basePath}/ExternalAPI/GetStoreDetailsFromCRM`,
  GetModelStoreDetails: `${basePath}/OrderSetup/GetModelStore`,
  GetFileDetails: `${basePath}/Inventory/GetInventoryFileDetails`,
  InventoryFileUpload: `${basePath}/Inventory/UploadInventoryFile`,
  SyncInventoryData: `${basePath}/Inventory/SyncStoreInventory`,
  SyncPurchaseHistoryData: `${basePath}/Common/SyncStorePurchaseHistory`,
  FileTemplateDownload: `${basePath}/Common/GetTemplatefile`,
  GetDataguideDetails: `${basePath}/DataGuide/GetDataGuideFileDetails`,
  DataguideUpload: `${basePath}/DataGuide/UploadDataGuide`,
  DataguideDownload: `${basePath}/DataGuide/DownloadDataGuide`,
  SaveDataguide: `${basePath}/DataGuide/SaveDataGuideData`,
  GetListFileDetails: `${basePath}/UploadItems/GetItemsFileDetails`,
  ItemListFileUpload: `${basePath}/UploadItems/UploadItemsFile`,

  // Manage Planograms
  GetDeptFilters: `${basePath}/MasterData/GetFilterData`,
  GetDeptList: `${basePath}/DepartmentTransaction/GetAllDepartmentData`,
  SaveDeptList: `${basePath}/DepartmentTransaction/SaveDepartmentData`,
  SaveDeptPONumber: `${basePath}/DepartmentTransaction/CreateDepartmentPONumber`,
  SaveDeptReleaseDate: `${basePath}/DepartmentTransaction/SaveDepartmentReleaseDate`,
  DeleteDeptReleaseDate: `${basePath}/DepartmentTransaction/DeleteDepartmentReleaseDate`,
  GetPogList: `${basePath}/PlanogramTransaction/GetAllPlanogramSummary`,
  SavePogList: `${basePath}/PlanogramTransaction/SavePlanogramTransaction`,
  SavePogReleaseDate: `${basePath}/PlanogramTransaction/SavePlanogramReleaseDate`,
  DeletePOGReleaseDate: `${basePath}/PlanogramTransaction/DeletePlanogramReleaseDate`,
  CreatePOGPONumber: `${basePath}/PlanogramTransaction/CreatePlanogramPONumber`,
  GetPogItemList: `${basePath}/ItemTransaction/GetAllItems`,
  SavePogItemList: `${basePath}/ItemTransaction/SaveItemTransaction`,
  SaveItemReleaseDate: `${basePath}/ItemTransaction/SaveItemReleaseDate`,
  DeleteItemReleaseDate: `${basePath}/ItemTransaction/DeleteItemReleaseDate`,
  CreateItemPONumber: `${basePath}/ItemTransaction/CreateItemPONumber`,
  CheckDuplicatePOGs: `${basePath}/PlanogramTransaction/GetDuplicatePlanograms`,
  PogBaseUrl: `${basePath}`,
  GetTotal: `/DepartmentTransaction/GetTotalSummary`,
  GetItemPogSummary: `/PlanogramTransaction/GetAllPlanogramSummary`,
  GetCountOfCompletedOrders: `${basePath}/OrderSetup/GetCountOfCompletedOrdersForMemberNbr`,
  ToggleStoreInvPurchaseHistory: `${basePath}/OrderSetup/ToggleStoreInvPurchaseHistory`,

  // Notes
  NotesBaseUrl: `${basePath}`,
  GetNotesListForStore: `/Notes/GetNotesListForStore`,
  GetNotesList: `/Notes/GetNotesList`,
  AddNote: `/Notes/AddNotes`,
  EditNote: `/Notes/EditNotes`,
  DeleteNote: `/Notes/DeleteNotes`,

  // Store Supplies
  GetSSPogList: `${basePath}/StoreSuppliesTransaction/GetStoreSuppliesPlanogramSummary`,
  SSPogSave: `${basePath}/StoreSuppliesTransaction/SaveStoreSuppliesPlanogramSummary`,
  SSPogCreatePO: `${basePath}/StoreSuppliesTransaction/CreateStoreSuppliesPlanogramPONumber`,
  SSPogSaveDate: `${basePath}/StoreSuppliesTransaction/SaveStoreSuppliesPlanogramReleaseDate`,
  SSPogDeleteDate: `${basePath}/StoreSuppliesTransaction/DeleteStoreSuppliesPlanogramReleaseDate`,
  SSOSOAutoSelect: `${basePath}/StoreSuppliesTransaction/SaveOSOSelectedstoreSupplies`,

  GetSSItemList: `${basePath}/StoreSuppliesTransaction/GetStoreSuppliesItemSummary`,
  SSItemSave: `${basePath}/StoreSuppliesTransaction/SaveStoreSuppliesItemSummary`,
  SSItemCreatePO: `${basePath}/StoreSuppliesTransaction/CreateStoreSuppliesItemsPONumber`,
  SSItemSaveDate: `${basePath}/StoreSuppliesTransaction/SaveStoreSuppliesItemsReleaseDate`,
  SSItemDeleteDate: `${basePath}/StoreSuppliesTransaction/DeleteStoreSuppliesItemReleaseDate`,

  SSDuplicatePogs: `${basePath}/StoreSuppliesTransaction/GetStoreSuppliesDuplicatePlanograms`,

  SSBaseUrl: `${basePath}`,

  GetSSTotal: `/StoreSuppliesTransaction/GetStoreSuppliesTotalSummary`,
  PogFileBasePath: "https://apps.membersonline.com/planogram/catalog/",

  // Okta Settings
  oktaIssuer: `${process.env.REACT_APP_OKTA_ISSUER}`,
  ...getEnvironmentSpecificSettings(env),
});

export default getConfig;
